export default __webpack_public_path__ + "static/media/black_texture_BG.18d7a821.png";